export default __webpack_public_path__ + "static/media/proj3_4.ef802f13.jpg";